<form [formGroup]="service.form" class="task__data">
  @if (taskType === TaskType.TYPE_CHANGE) {
    <div class="mb-4 task__data__tile">
      <div class="new-select-label">{{ 'Projects.changeTypeLabel' | translate }}</div>
      <ng-select
        ngSelectExtension
        class="w-100 new-select"
        [items]="changeTypes"
        [placeholder]="'Projects.changeTypePlaceholder' | translate"
        [notFoundText]="'Projects.notFoundTextTaskGroup' | translate"
        [tabIndex]="-1"
        bindLabel="name"
        bindValue="id"
        [searchable]="false"
        [formControlName]="service.TASK_SIDENAV_FORM.changeType"
      />
    </div>
  } @else if (!isProcessTaskContext) {
    <ul class="task__data__selection note-type-v2 mb-4">
      <ng-container *ngFor="let item of taskList">
        <li
          class="px-3 py-2 cursor-pointer"
          [ngClass]="{
            active: isActiveTaskTypeTab(item)
          }"
          (click)="!service?.task?.isDeleted ? this.setTypeActive(item) : null"
          [innerHTML]="item.name | translate"
        ></li>
      </ng-container>
    </ul>
  }

  @if (!isProcessTaskContext) {
    <div class="mb-4">
      <div class="new-select-label">{{ 'Projects.projectName' | translate }}</div>
      <project-selection
        class="w-100"
        [disabled]="!!service.task?.parent || !!service.connectedTask || !!service?.task?.isDeleted"
        [isFieldRequired]="!!service.isConfigChange || isProjectRequired"
        [requiredid]="service.projectID"
        [form]="service.form"
        [addTag]="canProjectAdd"
        [controlName]="service.TASK_SIDENAV_FORM.projectId"
        (onProjectClear)="resetProjectControl()"
      />
    </div>
  }

  <div *ngIf="taskType !== TaskType.TYPE_CHANGE && !isProcessTaskContext" class="mb-4">
    <div class="new-select-label">{{ 'Projects.taskGroupLabel' | translate }}</div>
    <ng-select
      ngSelectExtension
      class="w-100 new-select"
      [items]="taskGroups$ | async"
      [placeholder]="'Projects.chooseTaskGroup' | translate"
      [notFoundText]="'Projects.notFoundTextTaskGroup' | translate"
      [tabIndex]="-1"
      bindLabel="name"
      bindValue="id"
      [searchable]="false"
      [formControlName]="service.TASK_SIDENAV_FORM.groupId"
    />
  </div>

  <div class="mb-4">
    <input-v2
      #taskTitleInput
      [errMessages]="errorMessages(service.TASK_SIDENAV_FORM.description)"
      [class]="'required'"
      [disabled]="!!service?.task?.isDeleted"
      (onKeydown)="onEnter($event)"
      [formControlName]="service.TASK_SIDENAV_FORM.description"
      [placeholder]="titlePlaceholderKey | translate"
    />
  </div>

  <div
    *ngIf="!!service.connectedTask"
    class="mb-4 d-flex justify-content-between align-items-center task__data-connected-task"
  >
    <span>{{ 'Projects.connectedChange' | translate }}</span>
    <span class="task__data-connected-task-title elipsis" [title]="service.connectedTask.description">
      {{ service.connectedTask.description }}
    </span>
  </div>

  <div class="relative">
    <quill-editor
      #editor
      [bounds]="'.quill-custom-img-size'"
      class="quill-v2 quill-custom-img-size quill-custom-matcher"
      [modules]="modules('content')"
      [formats]="formats"
      [readOnly]="!!service?.task?.isDeleted"
      [placeholder]="descriptionPlaceholderKey | translate"
      [formControlName]="service.TASK_SIDENAV_FORM.content"
    />
  </div>

  <div class="mt-4">
    <div [hidden]="!service.isConfigChange">
      <task-selection-change-v2
        #financeTempl
        [message]="'Tasks.financeInfo' | translate"
        [items]="service.financial"
        [selectConfig]="{ placeholder: 'Tasks.selectType' | translate }"
        [title]="'Tasks.describeFinancialChange' | translate"
        [disabledInput]="isFinanceDisabled || !!service?.task?.isDeleted"
        [config]="{
          name: 'Tasks.enterChangeValue' | translate: { symbol: storage?.Company?.currency?.symbol },
          type: 'number'
        }"
        (changeEvent)="influenceChangeEvent($event, 'financeTempl', 'currentFinanceState')"
      />
    </div>

    <div [hidden]="!service.isConfigChange">
      <task-selection-change-v2
        #daysTempl
        [message]="'Tasks.daysInfo' | translate"
        [items]="service.days"
        [selectConfig]="{ placeholder: 'Tasks.selectType' | translate }"
        [title]="'Tasks.describeTime' | translate"
        [disabledInput]="isDateDisabled || !!service?.task?.isDeleted"
        [config]="{ name: 'Tasks.enterDaysCount' | translate, type: 'number' }"
        (changeEvent)="influenceChangeEvent($event, 'daysTempl', 'currentDateState')"
      />
    </div>

    <div
      [hidden]="!service.isConfigChange"
      *ngIf="
        !(
          service?.storage?.Employee?.isClient ||
          service?.storage?.Employee?.isWorker ||
          service?.storage?.Employee?.isExternalUser
        ) && service?.isChange
      "
      class="row mb-4"
    >
      <div class="col-12 new-select-label">{{ 'ProjectChanges.List.settlementStatus' | translate }}</div>
      <div class="col-12 col-sm-6">
        <ng-select
          [items]="settlementsItems"
          [bindValue]="'value'"
          [bindLabel]="'name'"
          [clearable]="false"
          [searchable]="false"
          [formControlName]="service.TASK_SIDENAV_FORM.settlementStatus"
          [tabIndex]="-1"
          [notFoundText]="'Projects.notFoundText' | translate"
          class="new-select"
          [readonly]="
            service.task?.isDeleted || (!service.permissionCtrl.edit && (service.isEdit || service.isPreview))
          "
        />
      </div>
    </div>

    <div [hidden]="!service.isConfigChange" *ngIf="!!service.isConfigChange && !storage?.Employee?.isClient">
      <div class="new-select-label red">{{ 'Projects.internalNote' | translate }}</div>
      <div class="relative mb-4">
        <quill-editor
          #internalNoteEditor
          [modules]="modules('internalNote')"
          [formats]="formats"
          [placeholder]="'Projects.enterInternalNote' | translate"
          [formControlName]="service.TASK_SIDENAV_FORM.internalNote"
          [bounds]="'.internal-note-bound'"
          class="quill-v2 quill-custom-img-size internal-note-bound"
        ></quill-editor>
      </div>
    </div>

    <div class="mb-4">
      <task-sidenav-blue />
    </div>
  </div>
</form>
